export const presets = [
  {
    // Minimal star
    icon: 'faStar',
    iconPack: 'font-awesome-solid',
    backgroundColor: '#ffffff',
    iconColor: '#FF4B4B',
    exactIconSize: 120,
    borderRadius: 0,
    borderWidth: 0,
    rotate: 0,
  },
  {
    // Soft rounded heart
    icon: 'faHeart',
    iconPack: 'font-awesome-solid',
    backgroundColor: '#FFE5E5',
    iconColor: '#FF4B4B',
    exactIconSize: 64,
    borderRadius: 64,
    borderWidth: 0,
    rotate: 0,
  },
  {
    // Dynamic rocket
    icon: 'faRocket',
    iconPack: 'font-awesome-solid',
    backgroundColor: '#1a1a1a',
    iconColor: '#FFD700',
    exactIconSize: 88,
    borderRadius: 16,
    borderWidth: 4,
    rotate: 45,
  },
  {
    // Royal shield
    icon: 'faShield',
    iconPack: 'font-awesome-solid',
    backgroundColor: '#4A148C',
    iconColor: '#ffffff',
    exactIconSize: 96,
    borderRadius: 8,
    borderWidth: 0,
    rotate: 0,
  },
  {
    // Elegant crown
    icon: 'faCrown',
    iconPack: 'font-awesome-solid',
    backgroundColor: '#FFD700',
    iconColor: '#1a1a1a',
    exactIconSize: 72,
    borderRadius: 32,
    borderWidth: 6,
    rotate: 0,
  },
  {
    // Geometric diamond
    icon: 'faDiamond',
    iconPack: 'font-awesome-solid',
    backgroundColor: '#E1F5FE',
    iconColor: '#0288D1',
    exactIconSize: 84,
    borderRadius: 0,
    borderWidth: 16,
    rotate: 45,
  },
  {
    // Modern gradient moon
    icon: 'faMoon',
    iconPack: 'font-awesome-solid',
    backgroundColor: '#2C3E50',
    iconColor: '#3498DB',
    exactIconSize: 92,
    borderRadius: 24,
    borderWidth: 2,
    rotate: -15,
  },
  {
    // Neon lightning
    icon: 'faBolt',
    iconPack: 'font-awesome-solid',
    backgroundColor: '#1A1A1A',
    iconColor: '#00FF9D',
    exactIconSize: 76,
    borderRadius: 12,
    borderWidth: 3,
    rotate: 0,
  },
  {
    // Minimalist leaf
    icon: 'faLeaf',
    iconPack: 'font-awesome-solid',
    backgroundColor: '#F0FFF4',
    iconColor: '#2E7D32',
    exactIconSize: 68,
    borderRadius: 40,
    borderWidth: 0,
    rotate: 30,
  },
  {
    // Abstract wave
    icon: 'faWaveSquare',
    iconPack: 'font-awesome-solid',
    backgroundColor: '#E3F2FD',
    iconColor: '#1976D2',
    exactIconSize: 80,
    borderRadius: 16,
    borderWidth: 4,
    rotate: 0,
  },
  {
    // Cosmic sun
    icon: 'faSun',
    iconPack: 'font-awesome-solid',
    backgroundColor: '#FF9800',
    iconColor: '#FFF3E0',
    exactIconSize: 88,
    borderRadius: 50,
    borderWidth: 8,
    rotate: 0,
  },
  {
    // Tech infinity
    icon: 'faInfinity',
    iconPack: 'font-awesome-solid',
    backgroundColor: '#212121',
    iconColor: '#64FFDA',
    exactIconSize: 72,
    borderRadius: 8,
    borderWidth: 2,
    rotate: 0,
  },
  {
    // Nature mountain
    icon: 'faMountain',
    iconPack: 'font-awesome-solid',
    backgroundColor: '#81C784',
    iconColor: '#1B5E20',
    exactIconSize: 84,
    borderRadius: 20,
    borderWidth: 0,
    rotate: 0,
  },
  {
    // Minimal compass
    icon: 'faCompass',
    iconPack: 'font-awesome-solid',
    backgroundColor: '#F5F5F5',
    iconColor: '#424242',
    exactIconSize: 64,
    borderRadius: 0,
    borderWidth: 12,
    rotate: 45,
  },
]
